import { render, staticRenderFns } from "./HeaderActions.vue?vue&type=template&id=2681eb8a&scoped=true&"
import script from "./HeaderActions.vue?vue&type=script&lang=js&"
export * from "./HeaderActions.vue?vue&type=script&lang=js&"
import style0 from "./HeaderActions.vue?vue&type=style&index=0&id=2681eb8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2681eb8a",
  null
  
)

export default component.exports